/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Typography } from 'design-system';

export function getLeadershipMessage(leadershipUser) {
  const message = leadershipUser?.message;
  if (typeof message !== 'string') {
    return '';
  }
  return message.trim();
}

export default function LeadershipMessageContent({ leadershipUser, className, component = 'div', variant, style }) {
  const message = getLeadershipMessage(leadershipUser);
  if (!message) {
    return null;
  }

  return (
    <Typography component={component} variant={variant} className={className} style={style}>
      {parse(message)}
    </Typography>
  );
}

LeadershipMessageContent.propTypes = {
  leadershipUser: PropTypes.shape({
    message: PropTypes.string,
  }),
  className: PropTypes.string,
  component: PropTypes.elementType,
  variant: PropTypes.string,
  style: PropTypes.shape({}),
};
